import { useState } from 'react';
import { TableContext } from './TableContext';
import { useSelected } from './useSelected';
export function TableContextProvider(props) {
    const { results = [], actions, children } = props;
    const [selected, setSelected] = useSelected(results);
    const [activeAction, setActiveAction] = useState();
    const hasBulkActions = Boolean(actions);
    return (<TableContext.Provider value={{
            activeAction,
            setActiveAction,
            selected,
            setSelected,
            results,
            actions: hasBulkActions,
        }}>
      {children}
      {actions}
    </TableContext.Provider>);
}
